<template>
  <div class="title">
    <div class="left">
      <slot>
        <span :class="{'hot':!plain }">{{leftStr}}</span>
        <span>{{rightStr}}</span>
      </slot>
      <img
        :src="icon"
        v-if="!plain"
      >

    </div>

    <div class="right">
      <slot name="right">

      </slot>
    </div>
  </div>
</template>

<script>

import { computed } from "vue";
export default {
  name: "HeaderTitle",
  props: {
    title: {
      type: String,
      default: "",
    },
    plain: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
      default: "",
    },
  },
  setup(props) {
    const leftStr = computed(() => props.title.slice(0, 2));
    const rightStr = computed(() => props.title.slice(2, 4));
    return {
      leftStr,
      rightStr,
    };
  },
};
</script>

<style lang="less" scoped>
.title {
  .space-between();
  margin: 20px 0 10px 0;

  .left {
    font-weight: bold;
    font-size: 18px;
    .hot {
      color: @theme-color;
    }
    img {
      height: 20px;
      margin: 0 0 10px 3px;
    }
  }
  .right {
    display: flex;
    font-size: @font-size-base;
    color: @gray-color;
    display: flex;
    align-items: flex-end;
  }
}
</style>